import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import FullscreenLoader from "../../../components/Common/FullscreenLoader.jsx";
import "../../../styles/Auth/supplier.css";
import Switch from '@mui/material/Switch';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import { getData, uploadFile, postData, deleteData, putData } from '../../../webService/webservice.js';
const SupplierPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isAddSupplier = location.pathname === '/suppliers/add';
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'left'
    };
    const headings = [
        'SL',
        'Supplier',
        'MobileNumber',
        'Email',
        'Address',
        'Status',
        'Action',
    ];
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#e6cf80',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };
    const [refreshKey, setRefreshKey] = useState(0);
    const [suppliers, setSuppliers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const sessionToken = sessionStorage.getItem("sessionToken");
    const [searchQuery, setSearchQuery] = useState('');
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [emailError, setEmailError] = useState("");
    const [stateError, setStateError] = useState("");
    const [countryError, setCountryError] = useState("");
    const [cityError, setCityError] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    const [editSupplierId, setEditSupplierId] = useState(null);
    const [SuppliersToDelete, setSuppliersToDelete] = useState(null);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        supplierName: '',
        supplierShortCode: '',
        contactPersonName: '',
        supplierType: '',
        mobileNumber: '',
        alternateMobileNumber: '',
        email: '',
        gstNumber: '',
        panNumber: '',
        addressLine1: '',
        addressLine2: '',
        landmark: '',
        city: '',
        district: '',
        state: '',
        country: '',
        pincode: '',
    });

    const handleOpen = (supplierId) => {
        setSuppliersToDelete(supplierId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSuppliersToDelete(null);
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const validateSupplierForm = (formData) => {
        let errors = {};

        // Supplier Name
        if (!formData.supplierName?.trim()) {
            errors.supplierName = "Supplier Name is required";
        }

        // Contact Person
        if (!formData.contactPersonName?.trim()) {
            errors.contactPersonName = "Contact Person Name is required";
        }

        if(!formData.supplierShortCode?.trim()) {
            errors.supplierShortCode = "Short Code is required";
        }

        // Supplier Type
        if (!formData.supplierType) {
            errors.supplierType = "Supplier Type is required";
        }

        // Mobile Number
        if (!formData.mobileNumber) {
            errors.mobileNumber = "Mobile Number is required";
        } else if (!/^\d{10}$/.test(formData.mobileNumber)) {
            errors.mobileNumber = "Mobile number must be exactly 10 digits";
        }

        // Email (optional but must be valid)
        if (formData.email && !/^\S+@\S+\.\S+$/.test(formData.email)) {
            errors.email = "Invalid email format";
        }

        // GST Number (optional, but if present must be valid)
        if (formData.gstNumber && !/^[0-9A-Z]{15}$/.test(formData.gstNumber)) {
            errors.gstNumber = "Invalid GST Number";
        }

        // PAN Number (optional)
        if (formData.panNumber && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.panNumber)) {
            errors.panNumber = "Invalid PAN Number";
        }

        // Address Line 1
        // if (!formData.addressLine1?.trim()) {
        //     errors.addressLine1 = "Address Line 1 is required";
        // }

        // City
        // if (!formData.city?.trim()) {
        //     errors.city = "City is required";
        // }

        // State
        // if (!formData.state?.trim()) {
        //     errors.state = "State is required";
        // }

        // Country
        // if (!formData.country?.trim()) {
        //     errors.country = "Country is required";
        // }

        // Pincode
        // if (!formData.pincode) {
        //     errors.pincode = "Pincode is required";
        // } else if (!/^\d{6}$/.test(formData.pincode)) {
        //     errors.pincode = "Pincode must be 6 digits";
        // }

        return errors;
    };

    const handleAddSupplier = async (e) => {
        e.preventDefault();
        const errors = validateSupplierForm(formData);

        if (Object.keys(errors).length > 0) {
            setErrors(errors);  // <-- Store errors to show under fields
            return;
        }
        setLoading(true);
        try {
            const token = sessionStorage.getItem("sessionToken");
            const supplierData = {
                supplierName: formData.supplierName,
                supplierShortCode: formData.supplierShortCode,
                contactPersonName: formData.contactPersonName,
                supplierType: formData.supplierType,
                mobileNumber: formData.mobileNumber,
                alternateMobileNumber: formData.alternateMobileNumber,
                email: formData.email,
                gstNumber: formData.gstNumber,
                panNumber: formData.panNumber,
                addressLine1: formData.addressLine1,
                addressLine2: formData.addressLine2,
                landmark: formData.landmark,
                city: formData.city,
                district: formData.district,
                state: formData.state,
                country: formData.country,
                pincode: formData.pincode,
                isActive: true
            };

            console.log("Sending Supplier data:", supplierData);
            const response = await postData('suppliers/', supplierData, token);
            toast.success(response.message || 'Supplier added successfully');
            setFormData({
                supplierName: "",
                supplierShortCode: "",
                contactPersonName: "",
                supplierType: "",
                mobileNumber: "",
                alternateMobileNumber: "",
                email: "",
                gstNumber: "",
                panNumber: "",
                addressLine1: "",
                addressLine2: "",
                landmark: "",
                city: "",
                district: "",
                state: "",
                country: "India",
                pincode: "",
            });
            navigate("/suppliers");
            fetchSuppliers(currentPage, limit, searchQuery);
        } catch (error) {
            console.error('Add Supplier Error:', error);
            toast.error(error.message || 'Add Supplier Failed');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSuppliers(currentPage, limit, searchQuery);
    }, [currentPage, limit, refreshKey, searchQuery]);

    const fetchSuppliers = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit,
            search: searchQuery?.trim() || "",
        }
        try {
            setLoading(true);
            const response = await getData('suppliers/suppliers', params, sessionToken);
            const resultsWrapper = response?.data;
            const supplierssList = resultsWrapper?.results || [];
            const totalCount = resultsWrapper?.totalItems || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setSuppliers(supplierssList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
            navigate("/suppliers");
        } catch (error) {
            toast.error(error.message || "Failed to fetch Suppliers");
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateSupplier = async (e) => {
        e.preventDefault();
        const errors = validateSupplierForm(formData);

        if (Object.keys(errors).length > 0) {
            setErrors(errors);  // <-- Store errors to show under fields
            return;
        }
        try {
            const token = sessionStorage.getItem("sessionToken");
            const updatedsuppliertData = {
                supplierName: formData.supplierName,
                supplierShortCode: formData.supplierShortCode,
                contactPersonName: formData.contactPersonName,
                supplierType: formData.supplierType,
                mobileNumber: formData.mobileNumber,
                alternateMobileNumber: formData.alternateMobileNumber,
                email: formData.email,
                gstNumber: formData.gstNumber,
                panNumber: formData.panNumber,
                addressLine1: formData.addressLine1,
                addressLine2: formData.addressLine2,
                landmark: formData.landmark,
                city: formData.city,
                district: formData.district,
                state: formData.state,
                country: formData.country,
                pincode: formData.pincode,
            };

            console.log("Updating Product with data:", updatedsuppliertData);

            const response = await putData(`suppliers/supplier/${editSupplierId}`, updatedsuppliertData, token);

            toast.success(response.message || 'Supplier updated successfully');

            // Step 4: Reset form and close modal
            setFormData({
                supplierName: "",
                supplierShortCode: "",
                contactPersonName: "",
                supplierType: "",
                mobileNumber: "",
                alternateMobileNumber: "",
                email: "",
                gstNumber: "",
                panNumber: "",
                addressLine1: "",
                addressLine2: "",
                landmark: "",
                city: "",
                district: "",
                state: "",
                country: "",
                pincode: "",
            });

            setIsPopupMode(false);
            setIsEditMode(false);
            fetchSuppliers(currentPage, limit);
            triggerRefresh();
        } catch (error) {
            toast.error("Error updating category.");
        }
    };

    const handleAlphabeticInput = (e, fieldName) => {
        const value = e.target.value;
        if (/^[a-zA-Z\s]*$/.test(value)) {
            setFormData((prev) => ({ ...prev, [fieldName]: value }));
            if (fieldName === "city") setCityError("");
            if (fieldName === "country") setCountryError("");
            if (fieldName === "state") setStateError("");
        } else {
            if (fieldName === "city") setCityError("Only letters and spaces allowed");
            if (fieldName === "country") setCountryError("Only letters and spaces allowed");
            if (fieldName === "state") setStateError("Only letters and spaces allowed");
        }
    };

    const handleToggle = async (supplierId, newStatus) => {
        try {
            const token = sessionStorage.getItem("sessionToken");

            const response = await putData(
                `suppliers/supplier/${supplierId}`,
                { isActive: newStatus },    // send true or false
                token
            );

            toast.success(response.message || "Status updated!");

            triggerRefresh();
        } catch (error) {
            console.error("Toggle Error:", error);
            toast.error("Failed to update status");
        }
    };

    const handleDeleteSupplier = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem('sessionToken');
            const response = await deleteData(`suppliers/supplier/${SuppliersToDelete}`, token);
            toast.success(response.message || "Supplier deleted successfully");
            setSuppliersToDelete(null);
            fetchSuppliers(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Supplier");
        }
    }

    const indianStates = [
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
        "Andaman and Nicobar Islands",
        "Chandigarh",
        "Dadra and Nagar Haveli and Daman & Diu",
        "Delhi",
        "Jammu & Kashmir",
        "Ladakh",
        "Lakshadweep",
        "Puducherry"
    ];

    return (
        <div className="supplier-layout">
            {loading && <FullscreenLoader />}
            <div className="supplier-content">
                <main className="supplier-main">
                    {isAddSupplier ? (
                        <div className="add-supplier-form">
                            <h3>Add Supplier</h3>
                            <form className="supplier-form">    
                                {/* ROW 1 - BASIC DETAILS */}
                                <div className="supplier-form-row">
                                    <div className="supplier-form-group">
                                        <label className="input-label">Supplier Name <span className="required">*</span></label>
                                        <input
                                            type="text"
                                            className={`supplier-input ${errors.supplierName ? "input-error" : ""}`}
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, supplierName: e.target.value }))
                                            }
                                        />
                                        {errors.supplierName && <p className="error-msg">{errors.supplierName}</p>}
                                    </div>

                                    <div className="supplier-form-group">
                                        <label className="input-label">Contact Person <span className="required">*</span></label>
                                        <input
                                            type="text"
                                            className={`supplier-input ${errors.contactPersonName ? "input-error" : ""}`}
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, contactPersonName: e.target.value }))
                                            }
                                        />
                                        {errors.contactPersonName && <p className="error-msg">{errors.contactPersonName}</p>}
                                    </div>

                                    <div className="supplier-form-group">
                                        <label className="input-label">Supplier Type <span className="required">*</span></label>
                                        <select
                                            className={`supplier-input ${errors.supplierType ? "input-error" : ""}`}
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, supplierType: e.target.value }))
                                            }
                                        >
                                            <option value="">Select Type</option>
                                            <option value="Individual">Individual</option>
                                            <option value="Weaver">Weaver</option>
                                            <option value="Manufacturer">Manufacturer</option>
                                            <option value="Wholesaler">Wholesaler</option>
                                            <option value="Distributor">Distributor</option>
                                            <option value="Trader">Trader</option>
                                        </select>
                                        {errors.supplierType && <p className="error-msg">{errors.supplierType}</p>}
                                    </div>
                                </div>

                                {/* ROW 2 - CONTACT DETAILS */}
                                <div className="supplier-form-row">
                                    <div className="supplier-form-group">
                                        <label className="input-label">Mobile Number <span className="required">*</span></label>
                                        <input
                                            type="text"
                                            className={`supplier-input ${errors.mobileNumber ? "input-error" : ""}`}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d{0,10}$/.test(value)) {
                                                    setFormData((prev) => ({ ...prev, mobileNumber: value }));
                                                }
                                            }}
                                        />
                                        {errors.mobileNumber && <p className="error-msg">{errors.mobileNumber}</p>}
                                    </div>

                                    <div className="supplier-form-group">
                                        <label className="input-label">Alternate Mobile</label>
                                        <input
                                            type="text"
                                            className="supplier-input"
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, alternateMobileNumber: e.target.value }))
                                            }
                                        />
                                    </div>

                                    <div className="supplier-form-group">
                                        <label className="input-label">Email</label>
                                        <input
                                            type="text"
                                            className={`supplier-input ${errors.email ? "input-error" : ""}`}
                                        />
                                        {errors.email && <p className="error-msg">{errors.email}</p>}
                                    </div>
                                </div>

                                {/* ROW 3 - TAX DETAILS */}
                                <div className="supplier-form-row">
                                    <div className="supplier-form-group">
                                        <label className="input-label">GST Number</label>
                                        <input
                                            type="text"
                                            className={`supplier-input ${errors.gstNumber ? "input-error" : ""}`}
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, gstNumber: e.target.value }))
                                            }
                                        />
                                        {errors.gstNumber && <p className="error-msg">{errors.gstNumber}</p>}
                                    </div>

                                    <div className="supplier-form-group">
                                        <label className="input-label">PAN Number</label>
                                        <input
                                            type="text"
                                            className={`supplier-input ${errors.panNumber ? "input-error" : ""}`}
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, panNumber: e.target.value }))
                                            }
                                        />
                                        {errors.panNumber && <p className="error-msg">{errors.panNumber}</p>}
                                    </div>

                                    <div className="supplier-form-group">
                                        <label className="input-label">Supplier Short Code <span className="required">*</span></label>
                                        <input
                                            type="text"
                                            className={`supplier-input ${errors.supplierShortCode ? "input-error" : ""}`}
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, supplierShortCode: e.target.value }))
                                            }
                                        />
                                        {errors.supplierShortCode && <p className="error-msg">{errors.supplierShortCode}</p>}
                                    </div>
                                </div>
                                {/* ROW 4 - ADDRESS */}
                                <div className="supplier-form-row">
                                    <div className="supplier-form-group">
                                        <label className="input-label">Address Line 1</label>
                                        <input
                                            type="text"
                                            className="supplier-input"
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, addressLine1: e.target.value }))
                                            }
                                        />
                                    </div>

                                    <div className="supplier-form-group">
                                        <label className="input-label">Address Line 2</label>
                                        <input
                                            type="text"
                                            className="supplier-input"
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, addressLine2: e.target.value }))
                                            }
                                        />
                                    </div>

                                    <div className="supplier-form-group">
                                        <label className="input-label">Landmark</label>
                                        <input
                                            type="text"
                                            className="supplier-input"
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, landmark: e.target.value }))
                                            }
                                        />
                                    </div>
                                </div>

                                {/* ROW 5 - CITY, STATE, PINCODE */}
                                <div className="supplier-form-row">
                                    <div className="supplier-form-group">
                                        <label className="input-label">City</label>
                                        <input
                                            type="text"
                                            className="supplier-input"
                                            onChange={(e) => handleAlphabeticInput(e, "city")}
                                        />
                                    </div>

                                    <div className="supplier-form-group">
                                        <label className="input-label">District</label>
                                        <input
                                            type="text"
                                            className="supplier-input"
                                            onChange={(e) => handleAlphabeticInput(e, "district")}
                                        />
                                    </div>

                                    <div className="supplier-form-group">
                                        <label className="input-label">
                                            State
                                        </label>

                                        <select
                                            className="supplier-input"
                                            value={formData.state || ""}
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, state: e.target.value }))
                                            }
                                        >
                                            <option value="">Select State</option>
                                            {indianStates.map((state) => (
                                                <option key={state} value={state}>
                                                    {state}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* ROW 6 */}
                                <div className="supplier-form-row">
                                    <div className="supplier-form-group">
                                        <label className="input-label">Country</label>
                                        <input
                                            type="text"
                                            className="supplier-input"
                                            onChange={(e) => handleAlphabeticInput(e, "country")}
                                        />
                                    </div>

                                    <div className="supplier-form-group">
                                        <label className="input-label">Pincode</label>
                                        <input
                                            type="text"
                                            className="supplier-input"
                                        />
                                    </div>
                                </div>

                                {/* BUTTONS */}
                                <div className="supplier-buttons">
                                    <button className="add-supplier-button" onClick={handleAddSupplier}>
                                        Add Supplier
                                    </button>
                                    <button className="cancel-supplier-button" onClick={() => navigate('/suppliers')}>
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <div className="supplier-widgets">
                                <div className="supplier-widgets-header">
                                    <h3>Suppliers</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="supplier-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <div className="add-supplier-buttons">
                                    <button className="add-btn-supplier" onClick={() => navigate('/suppliers/add')}>+ Add Supplier</button>
                                </div>
                            </div>
                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                maxHeight: 400,
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-supplier-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-supplier-head">
                                        <TableRow>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'left',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#e6cf80',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'left',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {suppliers.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'left', padding: '20px', fontWeight: 500 }}>
                                                        No suppliers found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            suppliers.map((supplier, index) => (
                                                <TableRow key={supplier._id}>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                    </TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{supplier.supplierName}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{supplier.mobileNumber}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{supplier.email}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{supplier.city}</Typography></TableCell>
                                                    <TableCell >
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                                                            <Switch
                                                                checked={supplier.isActive}
                                                                onChange={(e) => handleToggle(supplier._id, e.target.checked)}   // send id + status
                                                                sx={{
                                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                                        color: '#28A745',
                                                                    },
                                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                        backgroundColor: '#28A745',
                                                                    },
                                                                    '& .MuiSwitch-track': {
                                                                        backgroundColor: '#C10000',
                                                                    },
                                                                }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'left' }}>
                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                setFormData({
                                                                    supplierName: supplier.supplierName || "",
                                                                    supplierShortCode: supplier.supplierShortCode || "",
                                                                    contactPersonName: supplier.contactPersonName || "",
                                                                    supplierType: supplier.supplierType || "",

                                                                    mobileNumber: supplier.mobileNumber || "",
                                                                    alternateMobileNumber: supplier.alternateMobileNumber || "",
                                                                    email: supplier.email || "",

                                                                    gstNumber: supplier.gstNumber || "",
                                                                    panNumber: supplier.panNumber || "",

                                                                    addressLine1: supplier.addressLine1 || "",
                                                                    addressLine2: supplier.addressLine2 || "",
                                                                    landmark: supplier.landmark || "",

                                                                    city: supplier.city || "",
                                                                    district: supplier.district || "",
                                                                    state: supplier.state || "",
                                                                    country: supplier.country || "",

                                                                    pincode: supplier.pincode || "",
                                                                });
                                                                setEditSupplierId(supplier._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000' }}
                                                                onClick={() => handleOpen(supplier._id)}
                                                            />
                                                        </Box>

                                                    </TableCell>
                                                </TableRow>

                                            ))
                                        )}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="supplier-bottom">
                                <div className="supplier-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="supplier-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="supplier-section spacer"></div>
                                <div className="supplier-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setFormData({
                                                    supplierName: "",
                                                    supplierShortCode: "",
                                                    contactPersonName: "",
                                                    supplierType: "",
                                                    mobileNumber: "",
                                                    alternateMobileNumber: "",
                                                    email: "",
                                                    gstNumber: "",
                                                    panNumber: "",
                                                    addressLine1: "",
                                                    addressLine2: "",
                                                    landmark: "",
                                                    city: "",
                                                    district: "",
                                                    state: "",
                                                    country: "",
                                                    pincode: "",
                                                });
                                            }}
                                        />
                                        <div className="popup-form-supplier">
                                            <div className="supplier-popup-form">
                                                <h2 className="popup-title">
                                                    {isEditMode ? "Edit Supplier" : "Add Supplier"}
                                                </h2>                                                
                                                <form className="popup-form-body" onSubmit={handleUpdateSupplier}>
                                                    {/* ROW 1 - BASIC DETAILS */}
                                                    <div className="supplier-form-row">
                                                        <div className="supplier-form-group">
                                                            <label className="input-label">Supplier Name <span className="required">*</span></label>
                                                            <input
                                                                type="text"
                                                                className={`supplier-input ${errors.supplierName ? "input-error" : ""}`}
                                                                value={formData.supplierName}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({ ...prev, supplierName: e.target.value }))
                                                                }
                                                            />
                                                            {errors.supplierName && <p className="error-msg">{errors.supplierName}</p>}
                                                        </div>

                                                        <div className="supplier-form-group">
                                                            <label className="input-label">Contact Person <span className="required">*</span></label>
                                                            <input
                                                                type="text"
                                                                className={`supplier-input ${errors.contactPersonName ? "input-error" : ""}`}
                                                                value={formData.contactPersonName}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({ ...prev, contactPersonName: e.target.value }))
                                                                }
                                                            />
                                                            {errors.contactPersonName && <p className="error-msg">{errors.contactPersonName}</p>}
                                                        </div>

                                                        <div className="supplier-form-group">
                                                            <label className="input-label">Supplier Type <span className="required">*</span></label>
                                                            <select
                                                                className={`supplier-input ${errors.supplierType ? "input-error" : ""}`}
                                                                value={formData.supplierType}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({ ...prev, supplierType: e.target.value }))
                                                                }
                                                            >
                                                                <option value="">Select Type</option>
                                                                <option value="Individual">Individual</option>
                                                                <option value="Weaver">Weaver</option>
                                                                <option value="Manufacturer">Manufacturer</option>
                                                                <option value="Wholesaler">Wholesaler</option>
                                                                <option value="Distributor">Distributor</option>
                                                                <option value="Trader">Trader</option>
                                                            </select>
                                                            {errors.supplierType && <p className="error-msg">{errors.supplierType}</p>}
                                                        </div>
                                                    </div>

                                                    {/* ROW 2 - CONTACT DETAILS */}
                                                    <div className="supplier-form-row">
                                                        <div className="supplier-form-group">
                                                            <label className="input-label">Mobile Number <span className="required">*</span></label>
                                                            <input
                                                                type="text"
                                                                className={`supplier-input ${errors.mobileNumber ? "input-error" : ""}`}
                                                                value={formData.mobileNumber}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    if (/^\d{0,10}$/.test(value)) {
                                                                        setFormData((prev) => ({ ...prev, mobileNumber: value }));
                                                                    }
                                                                }}
                                                            />
                                                            {errors.mobileNumber && <p className="error-msg">{errors.mobileNumber}</p>}
                                                        </div>

                                                        <div className="supplier-form-group">
                                                            <label className="input-label">Alternate Mobile</label>
                                                            <input
                                                                type="text"
                                                                className="supplier-input"
                                                                value={formData.alternateMobileNumber}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({ ...prev, alternateMobileNumber: e.target.value }))
                                                                }
                                                            />
                                                        </div>

                                                        <div className="supplier-form-group">
                                                            <label className="input-label">Email</label>
                                                            <input
                                                                type="text"
                                                                className={`supplier-input ${errors.email ? "input-error" : ""}`}
                                                                value={formData.email}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({ ...prev, email: e.target.value }))
                                                                }
                                                            />
                                                            {errors.email && <p className="error-msg">{errors.email}</p>}
                                                        </div>
                                                    </div>

                                                    {/* ROW 3 - TAX DETAILS */}
                                                    <div className="supplier-form-row">
                                                        <div className="supplier-form-group">
                                                            <label className="input-label">GST Number</label>
                                                            <input
                                                                type="text"
                                                                className={`supplier-input ${errors.gstNumber ? "input-error" : ""}`}
                                                                value={formData.gstNumber}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({ ...prev, gstNumber: e.target.value }))
                                                                }
                                                            />
                                                            {errors.gstNumber && <p className="error-msg">{errors.gstNumber}</p>}
                                                        </div>

                                                        <div className="supplier-form-group">
                                                            <label className="input-label">PAN Number</label>
                                                            <input
                                                                type="text"
                                                                className={`supplier-input ${errors.panNumber ? "input-error" : ""}`}
                                                                value={formData.panNumber}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({ ...prev, panNumber: e.target.value }))
                                                                }
                                                            />
                                                            {errors.panNumber && <p className="error-msg">{errors.panNumber}</p>}
                                                        </div>
                                                        <div className="supplier-form-group">
                                                            <label className="input-label">Supplier Short Code <span className="required">*</span></label>
                                                            <input
                                                                type="text"
                                                                className={`supplier-input ${errors.supplierShortCode ? "input-error" : ""}`}
                                                                value={formData.supplierShortCode}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({ ...prev, supplierShortCode: e.target.value }))
                                                                }
                                                            />
                                                            {errors.supplierShortCode && <p className="error-msg">{errors.supplierShortCode}</p>}
                                                        </div>
                                                        
                                                    </div>

                                                    {/* ROW 4 - ADDRESS */}
                                                    <div className="supplier-form-row">
                                                        <div className="supplier-form-group">
                                                            <label className="input-label">Address Line 1</label>
                                                            <input
                                                                type="text"
                                                                className="supplier-input"
                                                                value={formData.addressLine1}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({ ...prev, addressLine1: e.target.value }))
                                                                }
                                                            />
                                                        </div>

                                                        <div className="supplier-form-group">
                                                            <label className="input-label">Address Line 2</label>
                                                            <input
                                                                type="text"
                                                                className="supplier-input"
                                                                value={formData.addressLine2}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({ ...prev, addressLine2: e.target.value }))
                                                                }
                                                            />
                                                        </div>

                                                        <div className="supplier-form-group">
                                                            <label className="input-label">Landmark</label>
                                                            <input
                                                                type="text"
                                                                className="supplier-input"
                                                                value={formData.landmark}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({ ...prev, landmark: e.target.value }))
                                                                }
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* ROW 5 - CITY, STATE, PINCODE */}
                                                    <div className="supplier-form-row">
                                                        <div className="supplier-form-group">
                                                            <label className="input-label">City</label>
                                                            <input
                                                                type="text"
                                                                className="supplier-input"
                                                                value={formData.city}
                                                                onChange={(e) => handleAlphabeticInput(e, "city")}
                                                            />
                                                        </div>

                                                        <div className="supplier-form-group">
                                                            <label className="input-label">District</label>
                                                            <input
                                                                type="text"
                                                                className="supplier-input"
                                                                value={formData.district}
                                                                onChange={(e) => handleAlphabeticInput(e, "district")}
                                                            />
                                                        </div>

                                                        <div className="supplier-form-group">
                                                            <label className="input-label">State</label>
                                                            <select
                                                                className="supplier-input"
                                                                value={formData.state}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({ ...prev, state: e.target.value }))
                                                                }
                                                            >
                                                                <option value="">Select State</option>
                                                                {indianStates.map((state) => (
                                                                    <option key={state} value={state}>{state}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {/* ROW 6 - COUNTRY + PINCODE */}
                                                    <div className="supplier-form-row">
                                                        <div className="supplier-form-group">
                                                            <label className="input-label">Country</label>
                                                            <input
                                                                type="text"
                                                                className="supplier-input"
                                                                value={formData.country}
                                                                onChange={(e) => handleAlphabeticInput(e, "country")}
                                                            />
                                                        </div>

                                                        <div className="supplier-form-group">
                                                            <label className="input-label">Pincode</label>
                                                            <input
                                                                type="text"
                                                                className="supplier-input"
                                                                value={formData.pincode}
                                                                onChange={(e) => {
                                                                    if (/^\d{0,6}$/.test(e.target.value)) {
                                                                        setFormData((prev) => ({
                                                                            ...prev,
                                                                            pincode: e.target.value
                                                                        }));
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* BUTTONS */}
                                                    <div className="supplier-buttons">
                                                        <button type="submit" className="add-supplier-button">
                                                            {isEditMode ? "Update Supplier" : "Add Supplier"}
                                                        </button>
                                                        
                                                        <button className="cancel-supplier-button" onClick={() => navigate('/suppliers')}>
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )}
                            {limit > 5 && suppliers.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more Suppliers
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                        Confirm Delete?
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                        Are you sure you want to delete this supplier?
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                        <Button variant="contained" color="error" sx={{ background: '#8D2629' }} onClick={handleDeleteSupplier}>
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    )
                    }
                </main>
            </div>
        </div>

    );
};

export default SupplierPage;